/**
 * Short audio chime — synthesized on the fly via Web Audio so we don't ship an MP3.
 * Two-note descending tone (~400ms total). Silent if AudioContext isn't available
 * or autoplay is blocked (modern browsers allow after first user interaction).
 */
let audioCtx: AudioContext | null = null;

function ctx(): AudioContext | null {
  if (audioCtx) return audioCtx;
  if (typeof window === 'undefined') return null;
  const Ctor =
    window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!Ctor) return null;
  try {
    audioCtx = new Ctor();
    return audioCtx;
  } catch {
    return null;
  }
}

export function playNewTicketChime() {
  const c = ctx();
  if (!c) return;
  // Browsers sometimes suspend the context until user interacts; resume if needed.
  if (c.state === 'suspended') c.resume().catch(() => undefined);

  const play = (freq: number, startOffset: number, duration: number, peakVol: number) => {
    const osc = c.createOscillator();
    const gain = c.createGain();
    osc.frequency.value = freq;
    osc.type = 'sine';
    const t = c.currentTime + startOffset;
    gain.gain.setValueAtTime(0.001, t);
    gain.gain.exponentialRampToValueAtTime(peakVol, t + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.001, t + duration);
    osc.connect(gain);
    gain.connect(c.destination);
    osc.start(t);
    osc.stop(t + duration);
  };

  // High note then a slightly lower note — quick, pleasant.
  play(880, 0, 0.18, 0.15);
  play(659.25, 0.13, 0.28, 0.12);
}
